import { apiRequest } from "./api";

export const FULL_ACCESS = {
  access_level: "owner",
  can_send_email: true,
  can_move_money: true,
};

export async function fetchAccess() {
  try {
    const me = await apiRequest("/auth/me");
    return {
      access_level: me.access_level || "owner",
      can_send_email: me.can_send_email !== false,
      can_move_money: me.can_move_money !== false,
    };
  } catch {
    return FULL_ACCESS;
  }
}
